import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ApiKey {
  id: string;
  name: string;
  workspace: string;
  siteId: string;
  appKey: string;
  created: string;
  lastUsed: string;
}

// Interface for tracking keys from API
export interface TrackingApiKey {
  id: string;
  tenantId: string;
  keyId: string;
  keyType: string;
  status: string;
  name: string;
  workspaceId: string;
  siteId: string;
  keyPrefix: string;
  createdAt: string;
  lastUsedAt: string | null;
}

// Interface for app keys from API
export interface AppApiKey {
  id: string;
  tenantId: string;
  keyId: string;
  keyType: string;
  status: string;
  name: string;
  workspaceId: string;
  siteId: string;
  keyPrefix: string;
  createdAt: string;
  lastUsedAt: string | null;
}

interface ApiKeysState {
  keys: ApiKey[];
  trackingKeys: TrackingApiKey[];
  appKeys: AppApiKey[];
  loading: boolean;
  error: string | null;
}

const initialState: ApiKeysState = {
  keys: [
    {
      id: '1',
      name: 'Fincity',
      workspace: 'Fincity',
      siteId: 'a3f500e3412863349cbe',
      appKey: '35034e2eb8d632cbbb21',
      created: '2 days ago',
      lastUsed: 'Yesterday',
    },
    {
      id: '2',
      name: 'Appiness',
      workspace: 'Appiness',
      siteId: '074f4a7c4ee875856bf0',
      appKey: '35034e2eb8d632cbbb21',
      created: '2 days ago',
      lastUsed: 'Never used',
    },
  ],
  trackingKeys: [],
  appKeys: [],
  loading: false,
  error: null,
};

const apiKeysSlice = createSlice({
  name: 'apiKeys',
  initialState,
  reducers: {
    addApiKey: (state, action: PayloadAction<ApiKey>) => {
      state.keys.unshift(action.payload);
    },
    updateApiKey: (state, action: PayloadAction<ApiKey>) => {
      const index = state.keys.findIndex((k) => k.id === action.payload.id);
      if (index !== -1) {
        state.keys[index] = action.payload;
      }
    },
    // Reducers for tracking keys
    setTrackingKeys: (state, action: PayloadAction<TrackingApiKey[]>) => {
      state.trackingKeys = action.payload;
      state.loading = false;
      state.error = null;
    },
    addTrackingKey: (state, action: PayloadAction<TrackingApiKey>) => {
      state.trackingKeys.unshift(action.payload);
    },
    setTrackingKeysLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTrackingKeysError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    // Reducers for app keys
    setAppKeys: (state, action: PayloadAction<AppApiKey[]>) => {
      state.appKeys = action.payload;
      state.loading = false;
      state.error = null;
    },
    addAppKey: (state, action: PayloadAction<AppApiKey>) => {
      state.appKeys.unshift(action.payload);
    },
    setAppKeysLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAppKeysError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  addApiKey,
  updateApiKey,
  setTrackingKeys,
  addTrackingKey,
  setTrackingKeysLoading,
  setTrackingKeysError,
  setAppKeys,
  addAppKey,
  setAppKeysLoading,
  setAppKeysError,
} = apiKeysSlice.actions;
export default apiKeysSlice.reducer;